/**
 * Helpers comuns aos repositórios de `user_settings` (uma linha por usuário;
 * cada repositório lê e grava só as chaves do seu assunto).
 */
import { AppError } from '@/shared/lib/appError'
import { toRepositoryError } from '@/shared/repositories/common/repositoryError'
import { supabase } from '@/shared/supabase/client'
import type { Json } from '@/shared/supabase/database.types'

export const getCurrentUserId = async (expectedUserId?: string): Promise<string> => {
  const { data, error } = await supabase.auth.getUser()
  if (error) {
    throw toRepositoryError(error, 'Não foi possível validar a sessão do usuário.', 401)
  }

  if (!data.user) {
    throw new AppError('Usuário não autenticado.', { status: 401, code: 'UNAUTHORIZED' })
  }

  if (expectedUserId !== undefined && data.user.id !== expectedUserId) {
    throw new AppError('Sessão alterada. Tente novamente.', { status: 401, code: 'UNAUTHORIZED' })
  }

  return data.user.id
}

export const toJsonObject = (value: Json | null | undefined): Record<string, Json | undefined> => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {}
  }

  return value as Record<string, Json | undefined>
}
